import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { message } from 'antd';
import './navbarShopy.css';

const NavbarShopy = ({ title }) => {
  const [isMenuOpen, setMenuOpen] = useState(true);
  const [userId, setUserId] = useState(null);
  const [nombreSucursal, setNombreSucursal] = useState('');
  const [isShopifySubscribed, setIsShopifySubscribed] = useState(false);

  const menuRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 920);

  useEffect(() => {
    const storedId = localStorage.getItem('usuario_id');
    if (storedId) {
      setUserId(storedId);
    }

    const handleResize = () => {
      const mobileView = window.innerWidth < 920;
      setIsMobile(mobileView);

      if (!mobileView) {
        setMenuOpen(true);
      }
    };

    const handleClickOutside = (event) => {
      if (isMobile && menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('resize', handleResize);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobile]);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario_id');
    localStorage.removeItem('rol_id');
    localStorage.removeItem('email');
    window.location.href = '/';
    message.success('Sesión cerrada exitosamente');
  };

  useEffect(() => {
    const fetchSucursal = async () => {
      const userId = localStorage.getItem('usuario_id');
      const token = localStorage.getItem('token');
  
      try {
        const response = await fetch(`https://99envios.app/api/online/sucursal/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        if (!response.ok) {
          throw new Error('Error al obtener la sucursal');
        }
        const data = await response.json();
        setNombreSucursal(data.nombre_sucursal);
      } catch (error) {
        console.error('Error al obtener la sucursal:', error);
      }
    };
  
    fetchSucursal();
  }, []);

  useEffect(() => {
    const verificarSucursalUsuario = async () => {
      const userId = localStorage.getItem('usuario_id');
      if (!userId) return;

      try {
        const response = await fetch(`https://integration.99envios.app/api/integration/shopify/v1/verificar-sucursal/${userId}`);
        const data = await response.json();
        setIsShopifySubscribed(data.message === 'El suscriptor está activo.');
      } catch (error) {
        console.error('Error al verificar suscripción:', error);
      }
    };

    verificarSucursalUsuario();
  }, []);

  return (
    <>
      <div className="navbar-top">
        <div className={`hamburger-menu ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <div className="bar1"></div>
          <div className="bar2"></div>
          <div className="bar3"></div>
        </div>
        <div className="navbar-tittle">
          <p>{title}</p>
        </div>
        <div className="user-info">
          <p>Hola, {nombreSucursal}</p>
          <NavLink to="/panel-usuario" className="panel-link">
            <p className="panel-link">99Panel</p>
          </NavLink>
          <div className="user-avatar">
            <img src="/Images/avatar-repartidor.jpg" alt="Avatar" />
          </div>
        </div>
      </div>
      <div className={`navbar-container ${isMenuOpen ? 'show' : 'hide'}`} ref={menuRef}>
        <div className="close-btn" onClick={toggleMenu}>X</div>
        <div className="navbar-title">
          <img src="/Images/download.png" alt="Download" className="logo" />
        </div>
        <div className="navbar-menu">
          <ul>
            <li>
              <NavLink to="/dashboard99" className={({isActive}) => isActive ? 'active' : ''} end>
                <span className="material-icons">dashboard</span>Dashboard
              </NavLink>
            </li>
            <li>
              <NavLink to="/shopify/listado" className={({isActive}) => isActive ? 'active' : ''}>
                <span className="material-icons">settings</span>
                {isShopifySubscribed ? 'Listado Shopify' : 'Configuración Shopify'}
              </NavLink>
            </li>
            <li>
              <NavLink to="/shopify/ordenes-shopify" className={({isActive}) => isActive ? 'active' : ''}>
                <span className="material-icons">list_alt</span>Órdenes Shopify
              </NavLink>
            </li>
            <li>
              <NavLink to="/" onClick={handleLogout} className={({isActive}) => isActive ? 'active' : ''}>
                <span className="material-icons">exit_to_app</span>Cerrar sesión
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default NavbarShopy;